<template>

  <vv-screen-wrapper>
    <div class="screen-container">
      <div v-if="favoriteBottles.length > 0 ">
        <mq-layout :mq="['mobile', 'tablet']">
          <div class="link-wrapper" v-for="favorite in favoriteBottlesList" :key="favorite.bottle.id">
              <favorite-bottle-list-item :tastingId="favorite.tasting.id" :bottle="favorite.bottle" :rating="favorite.rating" />
          </div>
        </mq-layout>

        <mq-layout :mq="['desktop']">
          <div class="desktop-tasting-item-wrapper" v-for="favorite in favoriteBottlesList" :key="favorite.bottle.id">
            <favorite-bottle-list-item :tastingId="favorite.tasting.id" :bottle="favorite.bottle" :rating="favorite.rating" />
          </div>
        </mq-layout>
      </div>
    </div>
  </vv-screen-wrapper>
</template>

<script>
import { mapGetters } from 'vuex'

import userMixin from '@/mixins/user'

import { VvButton } from '@/components/common'
import VvScreenWrapper from '@/components/common/VvScreenWrapper'
import FavoriteBottleListItem from '@/components/userAccount/FavoriteBottleListItem'

export default {
  name: 'FavoriteWines',
  components: { VvButton, VvScreenWrapper, FavoriteBottleListItem },
  mixins: [userMixin],
  data() {
    return {
      favoriteBottlesList: [],
      pushedFavoriteBottleId: []
    }
  },
  computed: {
    ...mapGetters({ favoriteBottles: 'favoriteBottles', tastingList: 'getTastings' }),
  },
  mounted() {
    for (const favorite of this.favoriteBottles) {
      let correspondingTasting = this.tastingList.find(el => el.bottleId == favorite.bottle.id)

      if (correspondingTasting && this.pushedFavoriteBottleId.indexOf(favorite.bottle.id) == -1) {
        this.favoriteBottlesList.push({
          tasting: correspondingTasting,
          bottle: favorite.bottle,
          rating: favorite.rating
        })
        this.pushedFavoriteBottleId.push(favorite.bottle.id)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.link-wrapper { 
  width: 50%;
  margin-bottom: 15px;
  display: inline-block;
  box-sizing: border-box;
  padding-right: 5px;
  padding-left: 5px;
}

.desktop-tasting-item-wrapper {
  margin-bottom: 15px;
  width: 25%;
  @media screen and (max-width: 1480px) {
    width: 33%;
  }
  @media screen and (max-width: 1024px){
    width: 40%;
  }
  display: inline-block;
  padding-right: 20px;
  box-sizing: border-box;
}

.NoTastings {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  .MainContainer {
    width: 60%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    // padding-left: 200px;
    position: relative;
    bottom: 50px;

    .Title {
      font-size: 2rem;
      font-family: Helvetica, sans-serif;
      margin-bottom: 57px;
      text-align: center;
    }

    .Subtitle {
      font-size: 1rem;
      font-family: Helvetica, sans-serif;
      margin-bottom: 30px;
      text-align: center;
    }

    .Cta {
      display: flex;
      margin-left: auto;
      margin-right: auto;
      justify-content: space-evenly;
      align-items: center;

      > * {
        font-size: 0.8rem;
        margin-left: 30px;
        margin-right: 30px;
      }
    }
  }

  .Illustration {
    width: 30%;

    img {
      width: 100%;
      height: auto;
    }
  }

  &--small {
    flex-direction: column;

    .MainContainer {
      bottom: -50px;
      width: 80%;

      .Title {
        font-size: 1.75rem;
      }

      .Cta {
        flex-direction: column;
        
        & > * {
          margin-left: 0;
          margin-right: 0;
          margin-bottom: 30px;
        }
      }
    }

    .Illustration {
      margin-top: 20px;
      width: 70%;
      overflow-y: hidden;
    }
  }
}
</style>
